<template>
  <!-- 2025.2.28 background/boxShadow -->
  <div
    class="navBar"
    :class="{ mobileNavBar: $route.path == '/console/chatting' }"
    :style="{
      background:
        $route.path == '/console/main'
          ? 'linear-gradient(90deg, #f7eeff 0%, #f2f0ff 60%, #e2e3ff 100%)'
          : '',
      boxShadow:
        $route.path == '/console/main'
          ? '0px 1px 13px 3px rgba(38, 59, 74, 0.04)'
          : '',
    }"
  >
    <!-- 导航栏 -->
    <div class="navContent">
      <!-- 左 -->
      <div class="navIconTmg" @click="$router.push('/console/main')">
        <img
          class="itemTmg1"
          src="@/assets/logo4.png"
          v-if="
            !clickTopShow &&
            ($route.path == '/console/finearts' ||
              $route.path == '/console/market')
          "
        />
        <img
          class="itemTmg1"
          src="@/assets/logo3.png"
          v-else-if="!clickTopShow"
        />
        <img class="itemTmg2" src="@/assets/logo.png" />
        <img
          v-if="clickTopShow"
          class="itemTmg3"
          :src="`https://img.cyuai.com/cpn/material/${
            $route.path == '/console/main'
              ? '8783928a1e19442ea524355f6b831f43'
              : '42e439bf3ff34e1ea6d4ec59381dedd5'
          }.gif?${dayjs().format('YYYYMMDDHH')}`"
          alt="img"
        />
        <span
          v-if="
            $route.path == '/console/finearts' ||
            $route.path == '/console/market'
          "
          class="meishu"
        >
          中国美术学院AI中心算力平台
        </span>
        <span v-if="user?.insider == 1 && metaModelType">
          {{ metaModelType }}
        </span>
      </div>
      <!-- 菜单 -->
      <div class="menuList">
        <div class="menuProject">
          <div
            class="menuProItem"
            :class="{ menuProIteAction: homeMenuType == 1 }"
            @click="menuProCli(1)"
          >
            应用商店
          </div>
          <div
            class="menuProItem"
            :class="{ menuProIteAction: homeMenuType == 2 }"
            @click="menuProCli(2)"
          >
            算力市场
          </div>
          <div
            class="menuProItem"
            :class="{ menuProIteAction: homeMenuType == 3 }"
            @click="menuProCli(3)"
          >
            晨羽Ai学院
          </div>
          <div
            class="menuProItem"
            :class="{ menuProIteAction: homeMenuType == 4 }"
            @click="menuProCli(4)"
          >
            大模型API服务
          </div>
          <div class="menuProItem" @click="window.open(this.http_Docs)">
            文档中心
          </div>
          <!-- <div
            class="menuProItem"
            @click="$router.push(`/console/shop?kw=${'天津大学'}`)"
          >
            天津大学训练营
          </div> -->
          <!-- <div
            class="menuProItem"
            :class="{ menuProIteAction: homeMenuType == 6 }"
            @click="menuProCli(6)"
          >
            训练LoRA
          </div> -->
        </div>
        <a-select
          class="menuSelect"
          :value="homeMenuType"
          popupClassName="popupDropdown_WidthFitContent"
        >
          <a-select-option :value="0" @click="menuProCli(0)">
            首页
          </a-select-option>
          <a-select-option :value="1" @click="menuProCli(1)">
            应用商店
          </a-select-option>
          <a-select-option :value="2" @click="menuProCli(2)">
            算力市场
          </a-select-option>
          <a-select-option :value="3" @click="menuProCli(3)">
            晨羽Ai学院
          </a-select-option>
          <a-select-option :value="4" @click="menuProCli(4)">
            大模型API服务
          </a-select-option>
          <a-select-option @click="window.open(this.http_Docs)">
            文档中心
          </a-select-option>
          <a-select-option :value="5" @click="menuProCli(5)">
            控制台
          </a-select-option>
          <!-- <a-select-option
            @click="$router.push(`/console/shop?kw=${'天津大学'}`)"
          >
            天津大学训练营
          </a-select-option> -->
          <!-- <a-select-option disabled :value="6">训练LoRA</a-select-option> -->
        </a-select>
      </div>
      <!-- 右 -->
      <div class="righSide">
        <div class="consolPagWai">
          <div
            id="consoleDivId"
            class="consolPage"
            :class="{ consolPageAction: homeMenuType == 5 }"
            @click="menuProCli(5)"
          >
            控制台
          </div>
          <div class="consolPage userName">
            <span
              v-if="user && user.display_name"
              @click="$router.push('/console/accountManage')"
            >
              {{ user && user.display_name }}
            </span>
            <span v-if="!token || !user" @click="navLoginCli">
              {{ "请登录~" }}
            </span>
          </div>
        </div>
        <!-- 用户 -->
        <a-popover
          v-if="token && user"
          placement="topLeft"
          trigger="click"
          arrow-point-at-center
          :mouseEnterDelay="0"
          :mouseLeaveDelay="0"
          :open="isTouch() ? null : userPopVisible"
        >
          <template #content>
            <div
              class="userImg_content"
              @mouseenter="
                clearTimeWare(() => {
                  userPopVisible = true;
                })
              "
              @mouseleave="userPopVisible = false"
            >
              <div class="userImg_top">
                <span v-if="user && user.display_name" class="displayName">
                  {{ user && user.display_name }}
                  <br />
                </span>
                {{ user && user.mobile }}
              </div>
              <div class="userImg_item" @click="logOut()">
                <LogoutOutlined class="userImg_icon" />
                <span>{{ $t("navLogOut") }}</span>
              </div>
              <div
                v-if="user?.insider == 1"
                class="userImg_item"
                @click="domainChangeNameVisible = true"
              >
                <SyncOutlined class="userImg_icon" />
                <span>更换调试域名</span>
              </div>
            </div>
          </template>
          <div class="userInfo">
            <div
              class="user_img"
              :style="`background-image: url(${
                (user && user.avatar_url) || profilePhoto
              });background-size: cover;background-repeat: no-repeat;background-position: center;`"
              @mouseenter="userPopVisible = true"
              @mouseleave="
                setTimeWare(() => {
                  userPopVisible = false;
                }, 150)
              "
            ></div>
          </div>
        </a-popover>
        <a-popover
          v-else
          placement="topLeft"
          arrow-point-at-center
          :open="unloggedADVisible"
        >
          <template #content>
            <div style="position: relative; width: 250px; height: 150px">
              <div
                style="
                  position: absolute;
                  right: 0;
                  top: 0;
                  width: 15px;
                  height: 15px;
                  cursor: pointer;
                "
                @click="unloggedADVisible = false"
              >
                <CloseOutlined />
              </div>

              123
            </div>
          </template>
          <div class="userInfo" style="cursor: pointer" @click="navLoginCli">
            <svg
              t="1734579236167"
              class="icon user_img"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="8588"
              width="35"
              height="35"
            >
              <path
                d="M938.671543 789.328457c8.528457-17.056914 17.056914-29.856914 25.6-46.928457 4.256914-4.271543 4.256914-8.528457 4.256914-12.8 4.271543-12.8 12.8-25.6 17.071543-38.4 4.271543-4.271543 4.271543-8.528457 4.271543-17.056914 4.271543-12.814629 8.528457-25.614629 12.8-34.143086 0-4.271543 4.256914-12.8 4.256914-17.071543 4.271543-12.8 4.271543-25.6 8.543086-38.4 0-4.256914 4.256914-12.8 4.256914-17.056914C1024 550.4 1024 529.071543 1024 512 1024 230.4 793.6 0 512 0S0 230.4 0 512c0 17.071543 0 38.4 4.271543 55.471543 0 4.256914 0 12.8 4.256914 17.056914 0 12.8 4.271543 25.6 4.271543 38.4 0 4.271543 4.256914 12.8 4.256914 17.071543 4.271543 12.8 8.543086 25.6 12.814629 34.143086 0 4.256914 4.256914 8.528457 4.256914 17.056914 4.271543 12.8 8.543086 25.6 17.071543 38.4 0 4.271543 4.271543 8.528457 4.271543 12.8 8.528457 17.071543 17.056914 29.871543 25.585371 46.928457C170.671543 930.128457 328.528457 1024 507.728457 1024s337.071543-93.871543 430.943086-234.671543c-4.271543 0-4.271543 0 0 0zM507.728457 243.2c102.4 0 187.743086 85.328457 187.743086 187.728457s-85.343086 187.743086-187.743086 187.743086-187.728457-85.343086-187.728457-187.743086 85.328457-187.728457 187.728457-187.728457z m-311.471543 588.8c55.471543-123.728457 174.943086-204.8 311.471543-204.8 136.543086 0 256.014629 81.071543 311.471543 204.8-81.071543 76.8-192 128-311.471543 128-119.456914-4.271543-230.4-51.2-311.471543-128z"
                fill="#666666"
                p-id="8589"
              ></path>
            </svg>
          </div>
        </a-popover>
      </div>
    </div>
    <!-- 登录弹框 -->
    <LoginModal
      v-if="loginModalVisible"
      @close="loginModalVisible = false"
    ></LoginModal>
    <!-- 设置域名弹框 -->
    <a-modal
      class="newFooter"
      centered
      v-model:open="domainChangeNameVisible"
      @ok="setDebugUrl"
      title="更换调试域名"
    >
      <a-divider></a-divider>
      <div
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 50px 0;
        "
      >
        <a-input
          style="width: calc(100% - 100px)"
          v-model:value="debugUrl"
          placeholder="输入您的域名"
        />
        <a-button class="newButtonDark" @click="debugUrl = manageUrl.baseUrl">
          重置
        </a-button>
      </div>
    </a-modal>
    <!-- 公告弹框 -->
    <a-modal
      v-for="(item, index) in noticePopList"
      :key="index"
      centered
      v-model:open="item.noticeModalVisible"
      cancelText="取消"
      okText="确定"
      class="houseNoticeNavBarClass"
      @cancel="noticePopCli(item, index)"
      :maskClosable="false"
    >
      <svg
        style="position: absolute; top: 20px; left: 20px"
        t="1726121944506"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="2435"
        width="36"
        height="36"
      >
        <path
          d="M949.333333 138.666667v640h-277.333333v170.901333L354.602667 778.666667H74.666667v-640h874.666666z m-64 64h-746.666666v512h232.064L608 842.432V714.666667h277.333333v-512zM277.333333 405.333333a42.666667 42.666667 0 1 1 0 85.333334 42.666667 42.666667 0 0 1 0-85.333334z m234.666667 0a42.666667 42.666667 0 1 1 0 85.333334 42.666667 42.666667 0 0 1 0-85.333334z m234.666667 0a42.666667 42.666667 0 1 1 0 85.333334 42.666667 42.666667 0 0 1 0-85.333334z"
          fill="#0074FF"
          p-id="2436"
        ></path>
      </svg>

      <div
        style="
          width: 100%;
          margin-top: 50px;
          margin-bottom: 20px;
          text-align: center;
          font-weight: 600;
          font-size: 24px;
          line-height: 28px;
        "
      >
        {{ item.title }}
      </div>
      <v-md-preview :text="item.content" class="md_pre"></v-md-preview>
      <div
        v-if="item.start_time"
        style="
          text-align: center;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
          line-height: 14px;
        "
      >
        发布时间：{{ item.start_time }}
      </div>

      <template #footer>
        <a-button
          class="button_primary"
          type="primary"
          @click="noticePopCli(item, index)"
        >
          确定
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
    
<script>
import {
  LogoutOutlined,
  SyncOutlined,
  DownOutlined,
  CloseOutlined,
} from "@ant-design/icons-vue";
import LoginModal from "@/components/loginModal.vue";
import manageUrl from "@/http/manage";
import dayjs, { Dayjs } from "dayjs";
export default {
  components: {
    LoginModal,
    LogoutOutlined,
    SyncOutlined,
    DownOutlined,
    CloseOutlined,
  },
  name: "navBar",
  data() {
    this.manageUrl = manageUrl;
    return {
      window,
      dayjs,
      profilePhoto: require("@/assets/profilePhoto.png"),
      // 用户弹框
      userPopVisible: false,
      // 弹框悬浮定时器
      popTimeout: null,

      // 登录弹框
      loginModalVisible: false,
      // 设置域名弹框
      domainChangeNameVisible: false,
      debugUrl: "",
      // 公告弹框
      noticePopList: [],
      // 未登录时广告弹框
      unloggedADVisible: false,
    };
  },
  watch: {
    loginModalVisible: {
      handler: function (t) {
        this.penetrationRoll(t ? "kai" : "guan");
      },
      immediate: false, // 这样初始化的时候也会触发
      deep: true, // 它会进行深度监听
    },
    loginPop: {
      handler: function (e) {
        // console.log(e);
        if (e && !this.token && !this.user) {
          this.changeLoginPopState(false);
          this.navLoginCli();
        }
      },
      immediate: true, // 这样初始化的时候也会触发
      deep: true, // 它会进行深度监听
    },
    $route: {
      handler: function (route) {
        // if (route.path == "/console/shop" && (!this.token || !this.user)) {
        //   this.unloggedADVisible = true;
        // } else {
        //   this.unloggedADVisible = false;
        // }
      },
      immediate: true, // 这样初始化的时候也会触发
      deep: true, // 它会进行深度监听
    },
  },
  props: {
    a: {
      type: String,
      default: "",
    },
  },
  created() {
    this.getNoticePop();
  },
  mounted() {
    this.debugUrl = localStorage["baseUrl"] || manageUrl.baseUrl;
    // console.log("触摸端", this.isTouch());
  },
  computed: {},
  methods: {
    // 切换菜单
    menuProCli(type) {
      switch (type) {
        case 0:
          this.$router.push("/console/main");
          break;
        case 1:
          this.$router.push("/console/shop");
          break;
        case 2:
          this.$router.push("/console/market");
          break;
        case 3:
          this.$router.push("/console/institute");
          break;
        case 4:
          this.$router.push("/console/apiServer");
          break;
        case 5:
          this.$router.push("/console/podExample");
          break;
        case 6:
          this.$router.push("/console/training");
          break;
      }
    },
    // 设置弹框悬浮定时器
    setTimeWare(fun, time) {
      this.popTimeout = setTimeout(() => {
        fun();
      }, time);
    },
    // 清除弹框悬浮定时器
    clearTimeWare(fun) {
      clearTimeout(this.popTimeout);
      this.popTimeout = null;
      fun();
    },
    // --------------------------------------
    // 登录
    navLoginCli() {
      this.loginModalVisible = true;
      this.userPopVisible = false;
    },
    // 退出登录
    logOut() {
      this.mixinLogOut();
    },
    // 设置调试域名
    setDebugUrl() {
      if (!this.debugUrl) {
        this.$message.error("请输入域名");
        return;
      }
      localStorage["baseUrl"] = this.debugUrl;

      this.$message.success("设置成功");
      this.domainChangeNameVisible = false;
      setTimeout(() => {
        location.reload();
      }, 1000);
    },
    // 请求公告列表
    getNoticePop() {
      this.$http
        .POST(this.$manageUrl.noticeList, {})
        .then((res) => {
          if (res) {
            this.noticePopList = res.result.notices
              .map((item) => {
                if (item.show_method == "popup") {
                  item.noticeModalVisible = true;
                  this.noticeTodayCliPopData.map((i) => {
                    if (
                      i.uuid == item.uuid &&
                      i.date.indexOf(dayjs().format("YYYY-MM-DD")) > -1
                    ) {
                      item.noticeModalVisible = false;
                    }
                  });
                  return item;
                }
              })
              .filter((item) => {
                return item;
              });
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
    // 点击公告弹框
    noticePopCli(param, index) {
      let oldList = this.noticeTodayCliPopData.map((item) => {
        if (item.uuid == param.uuid) {
          item.date =
            dayjs().format("YYYY-MM-DD") +
            "|" +
            dayjs().add(1, "day").format("YYYY-MM-DD");
        }
        return item;
      });

      let filterList = oldList.filter((item) => {
        return item.uuid == param.uuid;
      });
      if (!filterList.length) {
        oldList.push({
          date:
            dayjs().format("YYYY-MM-DD") +
            "|" +
            dayjs().add(1, "day").format("YYYY-MM-DD"),
          uuid: param.uuid,
        });
      }
      this.changeNoticeTodayCliPopDataState(oldList);
      this.noticePopList[index].noticeModalVisible = false;
    },
  },
};
</script>

<style lang="scss">
// 公告弹框
.houseNoticeNavBarClass {
  background-image: url("@/assets/noticeClassBackGrount.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 8px;
  .ant-modal-content {
    background: none;
  }
  .md_pre {
    .vuepress-markdown-body {
      padding: 2rem 0 !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.mobileNavBar {
  @media (max-width: 600px) {
    background: white;
    position: fixed !important;
    top: 0;
    z-index: 100;
  }
}
@media (max-width: 1200px) {
  .navBar {
    .navContent {
      // 左
      .navIconTmg {
        .itemTmg1 {
          display: none !important;
        }
        .itemTmg2 {
          display: flex !important;
        }
        .itemTmg3 {
          display: none !important;
        }
        .meishu {
          display: none !important;
        }
      }
    }
  }
}
@media (max-width: 1000px) {
  .navBar {
    .navContent {
      // 中间菜单
      .menuList {
        margin-right: auto;
        .menuProject {
          display: none !important;
        }
        .menuSelect {
          display: flex !important;
        }
      }
      // 右
      .righSide {
        .consolPagWai {
          display: none !important;
        }
      }
    }
  }
}
// 弹框
.ant-popover {
  // 用户信息
  .userImg_content {
    padding: 12px;
    margin: -12px;
    box-sizing: content-box;
    width: 124px;
    z-index: 1;
    position: relative;
    font-size: 15px;
    .userImg_top {
      border-bottom: solid 1px rgb(103, 58, 183, 0.5);
      margin-bottom: 10px;
      padding-bottom: 10px;
      box-sizing: border-box;

      .displayName {
        display: none;
      }
      @media (max-width: 1000px) {
        .displayName {
          display: flex;
        }
      }
    }
    .userImg_item {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-top: 5px;
      &:hover {
        color: rgb(103, 58, 183);
      }
      .userImg_icon {
        width: 17px;
        margin-right: 5px;
      }
    }
  }
}

.navBar {
  width: 100%;
  height: 52px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.06);
  z-index: 10;
  // 导航栏
  .navContent {
    width: 100%;
    max-width: 1500px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    overflow-x: overlay;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    // 左
    .navIconTmg {
      flex-shrink: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      .itemTmg1 {
        width: 116px;
      }
      .itemTmg2 {
        width: 50px;
        display: none;
      }
      .itemTmg3 {
        width: 116px;
      }
      .meishu {
        margin: 0 10px;
        color: #000000be;
        font-size: 16px;
        cursor: pointer;
        white-space: nowrap;
        font-weight: bold;
      }
    }
    // 中间菜单
    .menuList {
      flex-shrink: 0;
      height: 100%;
      display: flex;
      align-items: center;
      // 子菜单
      .menuProject {
        height: 100%;
        display: flex;
        align-items: center;
        .menuProItem {
          // height: 32px;
          display: flex;
          align-items: center;

          margin: 0 20px;
          padding-bottom: 5px;
          box-sizing: border-box;
          border-top: solid 3px rgba(0, 0, 0, 0);
          border-bottom: solid 3px rgba(0, 0, 0, 0);

          color: #000000be;
          font-size: 16px;
          cursor: pointer;
          white-space: nowrap;
          &:hover {
            border-bottom: solid 3px #6b82f9;
          }
        }
        .menuProIteAction {
          color: #6b82f9;
          // font-weight: 600;
          border-bottom: solid 3px #6b82f9;
        }
      }
      ::v-deep .menuSelect {
        display: none;
        .ant-select-selector {
          background: none;
          border: none;
        }
      }
    }
    // 右
    .righSide {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      .consolPagWai {
        height: 100%;
        display: flex;
        align-items: center;
        .consolPage {
          // height: 32px;
          display: flex;
          align-items: center;

          margin-left: 10px;
          padding-bottom: 5px;
          box-sizing: border-box;
          border-top: solid 3px rgba(0, 0, 0, 0);
          border-bottom: solid 3px rgba(0, 0, 0, 0);

          color: #000000be;
          font-size: 16px;
          cursor: pointer;
          white-space: nowrap;
          &:hover:not(.userName) {
            border-bottom: solid 3px #6b82f9;
          }
        }
        .consolPageAction {
          color: #6b82f9;
          // font-weight: 600;
          border-bottom: solid 3px #6b82f9;
        }
        .userName {
          margin-left: 30px;
        }
      }
      // 用户信息
      .userInfo {
        display: flex;
        align-items: center;
        .user_img {
          margin-left: 10px;
          border-radius: 50%;
          width: 35px;
          height: 35px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>